// extracted by mini-css-extract-plugin
export default {"root":"property_policies_root__DMGMC","title":"property_policies_title__69vbM","loading_container":"property_policies_loading_container__0DcU+"};